import { render, staticRenderFns } from "./novice-guide.vue?vue&type=template&id=49579500&scoped=true&"
import script from "./novice-guide.vue?vue&type=script&lang=js&"
export * from "./novice-guide.vue?vue&type=script&lang=js&"
import style0 from "./novice-guide.vue?vue&type=style&index=0&id=49579500&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49579500",
  null
  
)

export default component.exports